<template>
    <div>
        <b-carousel id="hero-slider" background="black" indicators>
            <slot></slot>
        </b-carousel>
    </div>
</template>

<script>
export default {
    methods: {},
    created() {
        // const request = axios.get("/api/slides").then(response => {
        //     console.log(response);
        //     this.slides = response.data.data;
        // });
    }
};
</script>

<style lang="scss">
.carousel-caption {
    left: 5%;
    top: 15%;
    width: 50%;
    text-align: left;
    h3 {
        font-size: 5rem;
        font-family: "Oswald", sans-serif;
        font-weight: 500;
        letter-spacing: 2px;
        @media (max-width: 1235px) {
            font-size: 2.2rem;
        }
        @media (max-width: 960px) {
            text-align: center;
            font-size: 2rem;
        }
        @media screen and (max-width: 630px) {
            font-size: 2rem;
        }
    }
    p {
        line-height: 1.6;
        font-size: 1.1rem;
        @media (max-width: 991px) {
            display: none;
        }
    }
    button.btn {
        @media screen and (max-width: 960px) {
            max-width: 50%;
            margin: 0 auto;
        }
    }
    @media screen and (max-width: 960px) {
        width: 60%;
        top: 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    @media screen and (max-width: 660px) {
        width: 80%;
        left: 10%;
    }
}
.carousel-item {
    width: 100vw;
}
</style>
